window.$('[data-toggle="tooltip"]').tooltip();